import script from "./AssignRoutePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignRoutePage.vue?vue&type=script&setup=true&lang=js"

import "./AssignRoutePage.vue?vue&type=style&index=0&id=fabb9ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fabb9ce4"]])

export default __exports__